import React from 'react';
import Icon from '../../../components/AppIcon';
import DealCard from './DealCard';

const DealKanban = ({ deals, onViewDetails, onUpdateStage }) => {
  const stages = [
    { id: 'inquiry', label: 'Inquiry', icon: 'FileText', color: 'muted' },
    { id: 'initial_contact', label: 'Initial Contact', icon: 'Phone', color: 'primary' },
    { id: 'negotiation', label: 'Negotiation', icon: 'MessageSquare', color: 'accent' },
    { id: 'due_diligence', label: 'Due Diligence', icon: 'Search', color: 'secondary' },
    { id: 'contract_finalization', label: 'Contract', icon: 'FileSignature', color: 'success' },
    { id: 'completed', label: 'Completed', icon: 'CheckCircle', color: 'success' }
  ];

  const getDealsByStage = (stageId) => {
    return deals?.filter(deal => deal?.currentStage === stageId) || [];
  };

  return (
    <div className="overflow-x-auto pb-4">
      <div className="flex gap-4 min-w-max">
        {stages?.map(stage => {
          const stageDeals = getDealsByStage(stage?.id);
          return (
            <div key={stage?.id} className="flex-shrink-0 w-80">
              <div className="bg-card border border-border rounded-lg">
                <div className={`bg-${stage?.color}/10 border-b border-border p-4`}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Icon name={stage?.icon} size={20} color={`var(--color-${stage?.color})`} />
                      <h3 className="font-semibold text-foreground">{stage?.label}</h3>
                    </div>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium bg-${stage?.color}/20 text-${stage?.color}`}>
                      {stageDeals?.length}
                    </span>
                  </div>
                </div>
                <div className="p-4 space-y-3 max-h-[calc(100vh-300px)] overflow-y-auto">
                  {stageDeals?.length === 0 ? (
                    <div className="text-center py-8 text-muted-foreground text-sm">
                      No deals in this stage
                    </div>
                  ) : (
                    stageDeals?.map(deal => (
                      <DealCard
                        key={deal?.id}
                        deal={deal}
                        onViewDetails={onViewDetails}
                        onUpdateStage={onUpdateStage}
                      />
                    ))
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DealKanban;